import Image from 'next/image';
import React, { type FC, type ReactNode } from 'react';

import EMPTY_ILLUSTRATION from '../../assets/images/empty-illustration.png';

import GetRecommendationsButton from './GetRecommendationsButton';

interface NoCoachResultsProps {
  heading: string;
  subheading: ReactNode;
}

export const NoCoachResults: FC<NoCoachResultsProps> = ({
  heading,
  subheading,
}) => {
  return (
    <div className="mt-20 flex flex-col items-center text-center">
      <Image
        src={EMPTY_ILLUSTRATION}
        width={131}
        height={140}
        alt="empty illustration image"
      />
      <h2 className="mt-6 text-2xl font-medium leading-7 text-leland-gray-dark">
        {heading}
      </h2>
      <p className="mt-2 text-lg leading-6 text-leland-gray-light">
        {subheading}
      </p>
      <GetRecommendationsButton className="mt-6" />
    </div>
  );
};
